export const sentryTag = "saleslead";

interface TemporaryTag {
  tagName: string;
  tagValue: string;
}

export const logError = (
  error: unknown,
  additionalTags: TemporaryTag[] = []
) => {
  if (error instanceof Error) {
    window?.xdk?.sentry?.captureException(
      error,
      sentryTag,
      "error",
      additionalTags
    );
  } else {
    logErrorMessage(JSON.stringify(error), additionalTags);
  }

  // eslint-disable-next-line no-console
  console.error(error, additionalTags);
};

export const logErrorMessage = (
  message: string,
  additionalTags: TemporaryTag[] = []
) => {
  window?.xdk?.sentry?.captureMessage(
    message,
    sentryTag,
    "error",
    additionalTags
  );

  // eslint-disable-next-line no-console
  console.error(message, additionalTags);
};
